module.exports = __webpack_public_path__ + "img/1_002.abc51d97.jpg";